// The `scan` interface: one queue for every engine scan, provided by plugin
// `shared-scan`, which scans the last 30 days automatically (on load and
// whenever games arrive). See docs/architecture/core/plugin-shared-scan.md.
export * from './types.ts';
export { ScanQueue, estimate, type ScanSources } from './queue.ts';

export const SCAN_API = 'scan';
